import {
	CurrentSubscription,
	Subscription,
	SubscriptionStatusEnum,
} from 'types/subscription'

import { adaptPmsProductToSubscriptionProduct } from './adaptPmsProduct'
import { PmsSubscription } from './pmsTypes'

// Best-effort adapter, same pattern as adaptPmsProduct.ts. Verified against the
// real PmsSubscription schema (PMS's own OpenAPI spec, 2026-08-10) rather
// than a populated live example — every test user hit so far has had no
// active subscription (404 api.errors.user.subscription.empty), so this is
// unverified against real subscription *data*, only the documented shape.
// Known gaps:
// - priceId/userId: no PMS field at all. Confirmed unused anywhere the
//   codebase reads a Subscription object — defaulted to ''.
// - updatedAt: no PMS field (only createdAt). Confirmed unused — defaulted
//   to createdAt's value.
// - product.label: types/subscription.ts's SubscriptionProduct (used by
//   Subscription.product) requires `label`, which doesn't exist on
//   features/purchase/subscriptionTypes's SubscriptionProduct (what the
//   mapper actually produces, matching the real render chain) — the same
//   duplicate-type split fixed elsewhere this session. Confirmed
//   `.product.label` is never read anywhere; cast below instead of adding
//   a fake value.
export const adaptPmsSubscriptionToSubscription = (
	subscription: PmsSubscription,
	locale: string,
): CurrentSubscription => ({
	id: subscription.id,
	createdAt: subscription.createdAt,
	updatedAt: subscription.createdAt,
	provider: subscription.provider,
	providerSubscriptionId: subscription.providerSubscriptionId,
	// String values are identical between PmsSubscriptionStatusEnum and
	// SubscriptionStatusEnum (both: initial/incomplete/active/cancelled/expired).
	status: subscription.status as unknown as SubscriptionStatusEnum,
	onTrial: subscription.onTrial,
	expiresAt: subscription.expiresAt,
	priceId: '',
	userId: '',
	product: adaptPmsProductToSubscriptionProduct(
		subscription.product,
		locale,
	) as Subscription['product'],
})
